import apiFetch from '../apiFetch'

export default function (token, paperworkTypeId) {
  return apiFetch({ endPoint: `paperworkType/Master/Info?paperworkTypeId=${paperworkTypeId}`, method: 'GET', body: null, token: token })
}
